export default {
  buttons: {
    send_code: 'Invia codice di accesso',
  },
  placeholders: {
    mobile_number: 'Numero di cellulare',
    email: 'Indirizzo email',
  },
  feedback: {
    phone_number_required: 'Inserisci il tuo numero di telefono',
    email_required: 'Inserisci il tuo indirizzo email',
  },
};
